export default __webpack_public_path__ + "static/media/mytheresa.272bacf4.PNG";